import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@site.rpc`,
    services: {
        status: {
            parameters: []
        },
        chooser: {
            parameters: [
                {
                    name: 'products',
                    type: 'array',
                    optional: true
                }
            ]
        }
    }
});
export default svc;
